import React from "react";

const PropertyGridSkeleton = () => {
  return (
    <div className="lg:col-span-2 space-y-4 scroll-overlay">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {Array.from({ length: 8 }).map((_, idx) => (
          <div
            key={idx}
            className="bg-white rounded-lg shadow-sm overflow-hidden animate-pulse"
          >
            {/* Image skeleton */}
            <div className="relative overflow-hidden aspect-[5/4] bg-gray-200"></div>

            {/* Text skeletons */}
            <div className="p-3 flex flex-col gap-y-2">
              <div className="h-3 bg-gray-200 rounded w-3/4"></div>
              <div className="h-2.5 bg-gray-200 rounded w-full"></div>
              <div className="h-2.5 bg-gray-200 rounded w-5/6"></div>

              <div className="flex items-center justify-between mt-2">
                <div className="h-3 bg-gray-200 rounded w-1/3"></div>
                <div className="h-2.5 bg-gray-200 rounded w-1/4"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyGridSkeleton;
